class Forms {
	constructor() {
		this.forms = document.querySelectorAll(".wpcf7");

		if (!this.forms) {
			return;
		}

		this.initInputEvents();
		this.initFormEvents();
	}

	initFormEvents() {
		this.forms.forEach(wpcf7Form => {
			this.submitEvents(wpcf7Form);
			this.wpcf7FailEvents(wpcf7Form);
			this.wpcf7SuccessEvents(wpcf7Form);
		});
	}

	initInputEvents() {
		const inputs = document.querySelectorAll(".input-container input:not([type=\"file\"]), .textarea-container textarea, .select-container select");

		inputs.forEach(input => {
			const inputContainer = input.closest(".field-container");

			input.addEventListener("focus", () => {
				inputContainer.classList.add("active");
			});

			input.addEventListener("blur", () => {
				inputContainer.classList.remove("active");

				if (input.value === "") {
					inputContainer.classList.remove("filled");
				} else {
					inputContainer.classList.add("filled");
				}
			});
		});

		// Managing input files
		const inputsFile = document.querySelectorAll(".field-container-file input:not([type=\"file\"])");
		inputsFile.forEach(input => {
			const inputContainer = input.closest(".field-container-file");
			const responseContainer = input.querySelector(".form-value");
			const responseValue = responseContainer.innerHTML;

			responseContainer.addEventListener("click", () => {
				input.click();
			});

			input.addEventListener("change", (event) => {
				let fileName = event.target.value.split('\\').pop();

				if (fileName) {
					responseContainer.innerHTML(fileName);
					inputContainer.classList.add("filled");
				} else {
					responseContainer.innerHTML(responseValue);
					inputContainer.classList.remove("filled");
				}
			});

			// Firefox bug fix
			input.addEventListener("focus", () => {
				input.classList.add("has-focus");
			});

			input.addEventListener("blur", () => {
				input.classList.remove("has-focus");
			});
		});
	}

	submitEvents(form) {
		const submitBtn = form.querySelector(".wpcf-submit, button.btn");
		submitBtn.addEventListener("click", () => {
			form.classList.add("loading");
		});
	}

	wpcf7FailEvents(form) {
		form.addMultipleEventListeners('wpcf7invalid wpcf7spam wpcf7mailfailed wpcf7unaccepted', () => {
			form.classList.remove("loading");
		});
	}

	wpcf7SuccessEvents(form) {
		form.addEventListener("wpcf7mailsent", () => {
			form.classList.remove("loading");
			form.classList.add("success");
			form.insertAdjacentHTML("beforeend", `
				<div class="form-success">
					<strong>Votre demande a bien<br>
					été prise en compte.</strong>
				</div>`);
			this.resetForm(form);
		});
	}

	resetForm(form) {
		setTimeout(function() {
			const successMessage = form.querySelector(".form-success");
			const inputs = form.querySelectorAll(".input-container");
			const resetBtn = form.querySelector("input[type='reset']");

			form.classList.remove("success");
			inputs.forEach(input => {
				input.classList.remove("filled");
			});
			resetBtn.click();
			successMessage.remove();
		}, 5000);
	}
}